/**
 * Convert dash-separated strings into camel case - if no dashes are present, do nothing
 * @param str
 * @returns
 */
export function kebabToCamelCase(str: string): string {
  if (!str.includes('-')) return str
  return str
    .split('-')
    .map((word, index) => {
      if (index === 0) return word.toLowerCase()
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join('')
}

/**
 * Remove accents from a string and convert it to lowercase
 * @param str
 * @returns
 */
export function normalize(str: string): string {
  return str
    .toLowerCase()
    .normalize('NFD') // separates letters and accents
    .replace(/[\u0300-\u036f]/g, '') // removes accents
    .trim()
}

// \s covers space/tab/NBSP/\uFEFF; add zero-width chars (\u200B-\u200D)
const GHOST_EDGE_RE = /^[\s\u200B-\u200D]+|[\s\u200B-\u200D]+$/g

/**
 * Remove leading/trailing whitespace and invisible characters often introduced by copy-paste.
 */
export function stripGhostSpaces<T>(value: T): T {
  if (typeof value !== 'string') return value
  return value.replace(GHOST_EDGE_RE, '') as T
}
